import { render, staticRenderFns } from "./ApuracaoAcaoRouter.vue?vue&type=template&id=3ea74bb1"
import script from "./ApuracaoAcaoRouter.vue?vue&type=script&lang=js"
export * from "./ApuracaoAcaoRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports